import React from 'react';
import PropTypes from 'prop-types';
import numeral from 'numeral';
import $ from 'jquery';
import _ from 'lodash';
import { withRouter } from 'react-router-dom';
import { inject, observer } from 'mobx-react';
import ChooseProductFirstHeadComponent from './ChooseProductFirstHeadComponent';
import ChooseProductSecondHeadComponent from './ChooseProductSecondHeadComponent';
import PrimaryButton from '../../shared_components/buttons/PrimaryButtonComponent';
import ShowComponent from '../../hocs/ShowComponent';
import ChooseProductMobileComponent from '../../shared_components/ChooseProductMobileComponent';
import ColumnSelectMobileComponent from './ColumnSelectMobileComponent';
import { setItemLocalStorage } from '../../../stores/tool/storage/storage';

@withRouter
@ShowComponent
@observer
class ChooseProductTable extends React.Component {
  constructor(props) {
    super(props);

    this.calculateBenefit = this.calculateBenefit.bind(this);
    this.setAssumptionData = this.setAssumptionData.bind(this);
  }

  setAssumptionData(labelId, initialInterest, fixedRateTerm) {
    // eslint-disable-next-line react/prop-types
    let selectedLabel = this.props.ProviderLabelData.allLabels.find(label => label.id === labelId);

    if (!selectedLabel) {
      selectedLabel = {
        providerName: '',
        labelName: '',
      };
    }

    // eslint-disable-next-line react/prop-types
    this.props.SavingsData.assumptionsData.forEach((assumption) => {
      if (_.keys(assumption)[0] === 'Verstrekker') {
        assumption.Verstrekker = selectedLabel.providerName;
      }

      if (_.keys(assumption)[0] === 'Product') {
        assumption.Product = selectedLabel.labelName;
      }

      if (_.keys(assumption)[0] === 'Looptijd rentevaste periode') {
        assumption['Looptijd rentevaste periode'] = `${fixedRateTerm} jaar`;
      }

      if (_.keys(assumption)[0] === 'Aanvangsrente') {
        assumption.Aanvangsrente = initialInterest;
      }
    });
  }

  calculateBenefit(labelId, initialInterest, fixedRateTerm) {
    this.props.SavingsData.termInterestSavingsSeries = [{
      name: 'rente',
      data: [0, 0],
    }, {
      name: 'korting',
      data: [0, 0],
    }];

    /* Clear LooptijdRenteTermInterestSavingsSeries from localStorage */
    localStorage.removeItem('LooptijdRenteTermInterestSavingsSeries');

    /* Reset loanpartsResult */
    this.props.SavingsData.loanpartsResult = {};

    const { labelInterests, calculateInterestSavings, calculateLoanparts } = this.props.ToolOverviewData;

    /* Get form data from calculation. */
    const baseFormData = this.props.CalculationFormData.setBaseFormData();

    /* Set labelId for AssumptionsComponent and to determine provider. Set initialInterest */
    this.setAssumptionData(labelId, initialInterest, fixedRateTerm);

    /* Clear error messages. */
    this.props.ValidationData.clearResponseErrors();

    /* Calculate interest savings for use in graph and assumptions in SavingsContainer */
    calculateInterestSavings(labelInterests, labelId, fixedRateTerm, baseFormData).then((response) => {
      /* Set term interest savings */
      const termInterestSavingsSeries = this.props.SavingsData.termInterestSavingsSeries;
      const withLooptijd = Math.floor(response.data.totalInterestWithLooptijdRente);
      const withoutLooptijd = Math.floor(response.data.totalInterestWithoutLooptijdRente);
      termInterestSavingsSeries[0].data = [0, withoutLooptijd - withLooptijd];
      termInterestSavingsSeries[1].data = [withoutLooptijd, withLooptijd];

      setItemLocalStorage(termInterestSavingsSeries, 'LooptijdRenteTermInterestSavingsSeries');

      this.props.SavingsData.termInterestSavingsSeries = termInterestSavingsSeries;
    });

    /* Calculate loanparts for overview in SavingsContainer */
    calculateLoanparts(labelId, fixedRateTerm, baseFormData).then((result) => {
      if (_.has(result, 'data')) {
        this.props.SavingsData.loanpartsResult = result.data;
        setItemLocalStorage(result.data, 'LooptijdRenteLoanpartsResult');
      }
    });

    // eslint-disable-next-line react/prop-types
    this.props.history.push('step-3');
  }

  render() {
    const {
      sortedFixedRateTerm,
      getFixedRateTermIndex,
      sortedOverviewTableColumn,
      showAllProviders,
    } = this.props.ToolOverviewData;

    const sortedColumnIndex = getFixedRateTermIndex(sortedFixedRateTerm);

    const selectedLabelInterests = showAllProviders ?
      // eslint-disable-next-line react/prop-types
      this.props.labelInterests : this.props.labelInterests.filter((label, index) => index < 10);

    /* Desktop version */
    const tableRows = selectedLabelInterests.map((label) => {
      const initialInterest = label.interests[sortedColumnIndex].initialInterest ?
        numeral(label.interests[sortedColumnIndex].initialInterest / 100).format('%0.00') : '-';
      const averageInterest = label.interests[sortedColumnIndex].averageInterest ?
        numeral(label.interests[sortedColumnIndex].averageInterest / 100).format('%0.00') : '-';

      return (
        <tr key={label.id}>
          <td>
            {<img src={label.logo} alt="logo" />}
          </td>
          <td>
            {label.product}
          </td>
          <td />
          <td
            className={sortedOverviewTableColumn === 'initialInterest' && 'bold'}
          >
            {initialInterest}
          </td>
          <td
            className={sortedOverviewTableColumn === 'averageInterest' && 'bold'}
          >{averageInterest}</td>
          <td>
            {(label.hasAutoRiskClassReduction &&
            <img src="/images/looptijdrente-icoon.png" alt="Ja" className="icon" />) || 'Nee'}
          </td>
          <td>
            <PrimaryButton
              text="Bereken uw voordeel"
              onClickHandler={() => { this.calculateBenefit(label.id, initialInterest, sortedFixedRateTerm); }}
              show
            />
          </td>
        </tr>
      );
    });

    const table = (
      <table className="choose-product-table">
        {/* Select fixed rate term */}
        <ChooseProductFirstHeadComponent />
        {/* Sort interest columns */}
        <ChooseProductSecondHeadComponent />
        <tbody>
          {tableRows}
        </tbody>
      </table>
    );

    const mobileList = (
      <ChooseProductMobileComponent
        labelInterests={this.props.labelInterests}
        calculateBenefit={this.calculateBenefit}
        sortedFixedRateTerm={this.props.ToolOverviewData.secondOverviewTableColumnFixedRateTerm}
        getFixedRateTermIndex={this.props.ToolOverviewData.getFixedRateTermIndex}
      >
        <ColumnSelectMobileComponent
          classNames={'choose-product__select-frt'}
        />
      </ChooseProductMobileComponent>
    );
    let component;
    const documentWidth = $(document).width();
    if (documentWidth > 800) {
      component = table;
    } else if (documentWidth <= 800) {
      component = mobileList;
    }

    return component;
  }
}

ChooseProductTable.propTypes = {
  ValidationData: PropTypes.shape({
    clearResponseErrors: PropTypes.func,
  }),
  CalculationFormData: PropTypes.shape({
    setBaseFormData: PropTypes.func,
  }),
  labelInterests: PropTypes.arrayOf(PropTypes.shape({})),
  SavingsData: PropTypes.shape({
    termInterestSavingsSeries: PropTypes.arrayOf(PropTypes.shape({})),
    assumptionsData: PropTypes.shape({}),
    loanpartsResult: PropTypes.shape({}),
  }),
  ProviderLabelData: PropTypes.shape({
    allLabels: PropTypes.oneOfType([
      PropTypes.shape({}),
      PropTypes.arrayOf(PropTypes.shape({})),
    ]),
  }),
  ToolOverviewData: PropTypes.shape({
    secondOverviewTableColumnFixedRateTerm: PropTypes.shape({
      secondOverviewTableColumnFixedRateTerm: PropTypes.number,
    }),
    calculateInterestSavings: PropTypes.func,
    calculateLoanparts: PropTypes.func,
    calculateBenefit: PropTypes.func,
    sortedOverviewTableColumn: PropTypes.string,
    sortedFixedRateTerm: PropTypes.number,
    labelInterests: PropTypes.arrayOf(PropTypes.shape({})),
    getFixedRateTermIndex: PropTypes.func,
    showAllProviders: PropTypes.bool,
  }),
};

ChooseProductTable.defaultProps = {
  ValidationData: {
    clearResponseErrors: () => {},
  },
  CalculationFormData: {
    setBaseFormData: () => {},
  },
  labelInterests: [],
  SavingsData: {
    termInterestSavingsSeries: [],
    assumptionsData: [],
    loanpartsResult: [],
  },
  ProviderLabelData: {
    allLabels: [],
  },
  ToolOverviewData: {
    calculateInterestSavings: () => {},
    calculateLoanparts: () => {},
    calculateBenefit: () => {},
    sortedOverviewTableColumn: '',
    sortedFixedRateTerm: 20,
    labelInterests: [],
    getFixedRateTermIndex: () => {},
    showAllProviders: false,
  },
};

export default inject(
  'ToolOverviewData',
  'ValidationData',
  'CalculationFormData',
  'SavingsData',
  'ProviderLabelData')(ChooseProductTable);
